<template>
	<div class="h-screen pt-6 flex flex-col bg-white">
		<Container class="w-full">
      <PageHeading :title="$t('pages.admin.devices.devices_admin_layout.admin_devices')"/>
		</Container>

		<TabLayout :tabs="tabs"/>

		<div class="flex-1 flex flex-col overflow-hidden">
			<router-view class="flex-1"></router-view>
		</div>

	</div>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "DevicesAdminLayout",
	components: {Container, PageHeading, TabLayout},
	data() {
		return {}
	},
	computed: {
		tabs() {
			return [
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.devices'),
					current: this.$route.name === 'admin.devices' || this.$route.name.startsWith('admin.devices.device'),
					to: {name: 'admin.devices'},
					permission: 'create:devices|update:devices',
				},
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.manufacturers'),
					current: this.$route.name === 'admin.devices.manufacturers' || this.$route.name.startsWith('admin.devices.manufacturers'),
					to: {name: 'admin.devices.manufacturers'},
					permission: 'create:device-manufacturers|update:device-manufacturers',
				},
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.types'),
					current: this.$route.name === 'admin.devices.types' || this.$route.name.startsWith('admin.devices.types'),
					to: {name: 'admin.devices.types'},
					permission: 'create:device-types|update:device-types',
				},
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.models'),
					current: this.$route.name === 'admin.devices.models' || this.$route.name.startsWith('admin.devices.models'),
					to: {name: 'admin.devices.models'},
					permission: 'create:device-models|update:device-models',
				},
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.revisions'),
					current: this.$route.name === 'admin.devices.revisions' || this.$route.name.startsWith('admin.devices.revisions'),
					to: {name: 'admin.devices.revisions'},
					permission: 'create:device-revisions|update:device-revisions',
				},
				{
					label: this.$t('pages.admin.devices.devices_admin_layout.third_party_firmwares'),
					current: this.$route.name === 'admin.devices.third-party-firmwares' || this.$route.name.startsWith('admin.devices.third-party-firmwares'),
					to: {name: 'admin.devices.third-party-firmwares'},
					permission: 'create:device-third-party-firmwares|update:device-third-party-firmwares',
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission, t.matchAll ?? false))
		}
	},
}
</script>

<style scoped>

</style>